// Orders API — endpoints injected into the single baseApi (ARCHITECTURE §7).
import { baseApi } from '@/lib/api/baseApi';
import { ordersEndpoints } from './orders.queries';

export const ordersApi = baseApi.injectEndpoints({ endpoints: ordersEndpoints });

export const {
  useCreateOrderMutation,
  useGetOrdersQuery,
  useGetOrderFilterOptionsQuery,
  useGetOrderDetailQuery,
  useGetOrderFormQuery,
  useUpdateOrderMutation,
  useDeleteOrderMutation,
  useGetOrderForShipmentQuery,
  useGetOrderForFulfillQuery,
  useCreateShipmentForOrderMutation,
  useGetOrderLinkedShipmentsQuery,
  useGetLinkableOutgoingShipmentsForOrderQuery,
  useGetOrderAllocationsQuery,
  useDispatchOrderMutation,
} = ordersApi;
